import { useCareerProfessionsQuery } from 'core';

import { IProfession, transformProfessions } from './transform';

/**
 * ТЗ 0039, доводка UX — справочник профессий.
 *
 * `cache-and-network`, как у остальных экранов раздела: список меняется редко
 * (треки заводит методист), но «есть у меня» зависит от навыков студента и
 * обязано освежаться, когда он вернулся сюда после начисления за курс.
 */
export const useProfessions = () => {
  const { data, loading } = useCareerProfessionsQuery({
    fetchPolicy: 'cache-and-network',
  });

  const professions: IProfession[] = transformProfessions(data);
  return { professions, loading };
};
